module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step4-ES.0177a7ab.png";